module["exports"] = [
  "6759-####-####-###L",
  "6759-####-####-####-#L",
  "6759-####-####-####-##L"
];
